<template>
  <v-app>
    <v-main class="torneo-background">
      <v-container fluid>
        <!-- FILTROS Y BÚSQUEDA -->
        <v-card class="mb-6">
          <v-btn
            class="refresh-button mx-2"
            fab
            dark
            x-small
            color="success"
            @click="refresh"
          >
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
          <h2 class="mb-4 inline-block">Buscar Competiciones</h2>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" sm="6">
                <v-text-field
                  v-model="filtros.buscar"
                  label="Nombre Competición"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  maxlength="80"
                  @input="onFiltroChange"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="6">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fechaFormateada"
                      label="Fecha desde / hasta"
                      readonly
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filtros.fecha"
                    locale="es-ar"
                    range
                    @change="onFiltroChange"
                    outlined
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="4" sm="6">
                <v-select
                  v-model="filtros.deporte"
                  :items="deportesFiltros"
                  label="Deporte"
                  @change="onFiltroChange"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-select
                  v-model="filtros.sistemaCompetencia"
                  :items="sistemasFiltros"
                  label="Sistema Competencia"
                  @change="onFiltroChange"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-select
                  v-model="filtros.genero"
                  :items="generosFiltros"
                  label="Genero"
                  @change="onFiltroChange"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-select
                  v-model="filtros.categoria"
                  :items="categoriasFiltros"
                  label="Categoría"
                  @change="onFiltroChange"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-select
                  v-model="filtros.estado"
                  :items="estadosFiltros"
                  label="Estado"
                  @change="onFiltroChange"
                  outlined
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="filtrosActivos">
              <v-col cols="12">
                <v-chip-group column>
                  <v-chip
                    v-if="filtros.buscar"
                    close
                    color="primary"
                    dark
                    @click:close="quitarFiltro('buscar')"
                  >
                    Nombre Competición: {{ filtros.buscar }}
                  </v-chip>

                  <v-chip v-if="fechaFormateada" color="primary" dark>
                    Rango Fecha: {{ fechaFormateada }}
                  </v-chip>

                  <v-chip color="primary" dark v-if="filtros.deporte">
                    Deporte: {{ filtros.deporte }}
                  </v-chip>

                  <v-chip
                    :color="getSistemaColor(filtros.sistemaCompetencia)"
                    dark
                    v-if="filtros.sistemaCompetencia"
                  >
                    Sistema Competencia: {{ filtros.sistemaCompetencia }}
                  </v-chip>

                  <v-chip color="primary" dark v-if="filtros.genero">
                    Género: {{ filtros.genero }}
                  </v-chip>

                  <v-chip color="primary" dark v-if="filtros.categoria">
                    Categoría: {{ filtros.categoria }}
                  </v-chip>

                  <v-chip
                    v-if="filtros.estado"
                    :color="getEstadoColor(filtros.estado)"
                  >
                    Estado: {{ filtros.estado }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="filtrosActivos"
                    close
                    @click:close="limpiarFiltros"
                    color="grey"
                    dark
                  >
                    Resetear filtros
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- TABLA DE TORNEOS -->
        <v-card>
          <v-card-title>
            Competiciones
            <v-spacer></v-spacer>
            <span class="text-caption grey--text">
              Mostrando {{ torneos.length }} de {{ cantRegistros }}
            </span>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="torneos"
            :loading="cargando"
            disable-sort
            disable-filtering
            :options.sync="opcionesTabla"
            :footer-props="footerProps"
            :server-items-length="cantRegistros"
            locale="es-ar"
            class="elevation-1"
          >
            <template v-slot:item.sistemaCompetencia="{ item }">
              <v-chip
                :color="getSistemaColor(item.sistemaCompetencia)"
                dark
                small
              >
                {{ item.sistemaCompetencia.toUpperCase() }}
              </v-chip>
            </template>

            <!-- COLUMNA ESTADO -->
            <template v-slot:item.estado="{ item }">
              <v-chip :color="getEstadoColor(item.estado)" dark small>
                {{ item.estado.toUpperCase() }}
              </v-chip>
            </template>

            <!-- COLUMNA MODALIDAD -->
            <template v-slot:item.modalidad="{ item }">
              <v-chip
                :color="
                  item.modalidad === 'eliminacion_directa' ? 'blue' : 'green'
                "
                small
              >
                {{
                  item.modalidad === "eliminacion_directa"
                    ? "Eliminación"
                    : "Zonas + Eliminación"
                }}
              </v-chip>
            </template>

            <!-- COLUMNA ACCIONES -->
            <template v-slot:item.acciones="{ item }">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click="
                        abrirTorneo(
                          item.idTorneo,
                          item.idInstitucion,
                          item.sistemaCompetencia,
                        )
                      "
                      v-on="on"
                    >
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Ir a la competición</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="warning"
                      @click="editarTorneo(item)"
                      v-on="on"
                      class="ml-1"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar información</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="indigo"
                      @click="inscripciones(item)"
                      v-on="on"
                      class="ml-1"
                    >
                      <v-icon small>mdi-format-list-numbered</v-icon>
                    </v-btn>
                  </template>
                  <span>Lista de Inscriptos</span>
                </v-tooltip>

                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small color="grey" v-on="on" class="ml-1">
                      <v-icon small>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      @click="cambiarEstado(item.idTorneo, 'Publicado')"
                      v-if="
                        item.estado === 'Draft' || item.estado === 'Finalizado'
                      "
                    >
                      <v-list-item-icon>
                        <v-icon small color="success">mdi-earth</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{
                        item.estado === "Draft"
                          ? "Publicar"
                          : "Volver a Publicado"
                      }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      @click="cambiarEstado(item.idTorneo, 'Draft')"
                      v-if="item.estado === 'Publicado'"
                    >
                      <v-list-item-icon>
                        <v-icon small color="warning">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Volver a draft</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      @click="eliminarTorneo(item.idTorneo)"
                      class="red--text"
                    >
                      <v-list-item-icon>
                        <v-icon small color="red">mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tooltip bottom v-if="item.estado === 'Finalizado'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click="editarPuntos(item)"
                      v-on="on"
                      class="ml-1"
                    >
                      <v-icon small>mdi-podium</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar puntos jugadores</span>
                </v-tooltip>
              </div>
            </template>

            <!-- SIN DATOS -->
            <template v-slot:no-data>
              <div class="text-center py-4">
                <v-icon size="64" color="grey lighten-2"
                  >mdi-trophy-outline</v-icon
                >
                <p class="subtitle-1 grey--text mt-2">
                  No hay competiciones que coincidan con los filtros ingresados
                </p>
                <v-btn color="primary" @click="abrirNuevoTorneo" class="mt-2">
                  <v-icon left>mdi-plus</v-icon>
                  Crear primer competición
                </v-btn>
              </div>
            </template>

            <!-- CARGANDO -->
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
          </v-data-table>

          <v-card-actions>
            <v-btn dark color="#24232d" @click="volver">
              <v-icon left>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="abrirNuevoTorneo">
              <v-icon left>mdi-plus</v-icon>
              Nueva Competición
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>

    <!-- MODAL NUEVO TORNEO -->
    <v-dialog v-model="modalNuevoVisible" max-width="600" persistent>
      <v-card class="glass-card mb-0">
        <!-- Header -->
        <v-card-title class="modal-title mb-4">
          <v-icon left color="green">
            {{ torneoEditando ? "mdi-pencil" : "mdi-trophy" }}
          </v-icon>
          {{ torneoEditando ? "Editar Competición" : "Nueva Competición" }}
        </v-card-title>

        <!-- Content -->
        <v-card-text>
          <v-form ref="formTorneo" v-model="formValido">
            <v-text-field
              v-model="nuevoTorneo.nombre"
              label="Nombre de la competición"
              :rules="[(v) => !!v || 'Nombre es requerido']"
              required
              outlined
              dense
              maxlength="80"
              class="mb-4"
            />

            <v-textarea
              v-model="nuevoTorneo.descripcion"
              label="Descripción (opcional)"
              rows="3"
              outlined
              dense
              class="mb-4"
            />

            <v-row dense>
              <v-col cols="12">
                <v-select
                  v-model="nuevoTorneo.deporte"
                  :items="deportesModel"
                  :disabled="!!torneoEditando"
                  label="Deporte"
                  :rules="[(v) => !!v || 'Deporte es requerido']"
                  required
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  ref="fecha"
                  v-model="nuevoTorneo.fecha"
                  label="Fecha Inicio"
                  type="date"
                  :rules="[(v) => !!v || 'La fecha es requerida']"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="nuevoTorneo.sistemaCompetencia"
                  :items="sistemas"
                  label="Sistema de Competencia"
                  :rules="[(v) => !!v || 'Sistema de competencia es requerido']"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-row dense v-if="nuevoTorneo.deporte !== 'Futbol'">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="nuevoTorneo.tipoCompetencia"
                  :items="tiposCompetencia"
                  label="Tipo de Competencia"
                  :rules="[(v) => !!v || 'Tipo de competencia es requerido']"
                  required
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="nuevoTorneo.categoria"
                  :items="categoriasModel"
                  label="Categoría"
                  :rules="[(v) => !!v || 'Categoría es requerida']"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="nuevoTorneo.genero"
                  :items="generos"
                  label="Género"
                  :rules="[(v) => !!v || 'Género es requerido']"
                  required
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="nuevoTorneo.valorInscripcion"
                  label="Valor Inscripción por Jugador"
                  outlined
                  dense
                  maxlength="10"
                  class="mb-4"
                  :rules="valorInscripcionRules"
                  @blur="toFixed"
                  @keypress="onlyNumber"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="modal-actions">
          <v-spacer />
          <v-btn text color="grey lighten-1" @click="cerrarModalNuevo">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            elevation="2"
            @click="guardarTorneo"
            :loading="guardando"
            :disabled="!formValido"
          >
            <v-icon left>
              {{ torneoEditando ? "mdi-content-save" : "mdi-arrow-right" }}
            </v-icon>
            {{ torneoEditando ? "Actualizar" : "Crear y configurar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <lista-inscriptos
      :visible="modalInscripciones"
      :idTorneo="editedItem.idTorneo"
      :infoTorneo="editedItem.infoTorneo"
      :sistemaCompetencia="editedItem.sistemaCompetencia"
      @close="modalInscripciones = false"
    />

    <modal-finalizar-competencia
      :visible="modalFinalizarVisible"
      :jugadores="jugadoresFinales"
      :tipo-competencia="editedItemFinaliza.tipoCompetencia"
      :nombre-competencia="editedItemFinaliza.nombreTorneo"
      :categoria="editedItemFinaliza.categoriaTorneo"
      :genero="editedItemFinaliza.generoTorneo"
      :id-ranking="idRanking"
      @close="modalFinalizarVisible = false"
      @finalizar="actualizarPuntos"
    />
  </v-app>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, watch, getCurrentInstance } from "vue";
import axios from "@/axios-auth";
import router from "@/router";
import { showAlert, confirmModal } from "@/utils/toast";
import moment from "moment";
import { debounce } from "lodash";
import { getCategoriasConfig, getDeportesConfig } from "@/utils/models";
import ListaInscriptos from "./ListaInscriptos.vue";
import ModalFinalizarCompetencia from "./ModalFinalizarCompetencia.vue";
import type { JugadorParaFinalizar } from "@/utils/rankings";

const { proxy } = getCurrentInstance();

const menu = ref(false);
const fechaFormateada = ref("");

// Estado
const modalFinalizarVisible = ref(false);
const jugadoresFinales = ref<JugadorParaFinalizar[]>([]);
const idRanking = ref<Number | undefined>(undefined);

const cargando = ref(false);
const torneos = ref<any[]>([]);
const filtros = ref({
  buscar: "",
  estado: "Todos",
  genero: "Todos",
  categoria: "Todos",
  sistemaCompetencia: "Todos",
  deporte: "Todos",
  fecha: ["", ""],
});
const opcionesTabla = ref({
  page: 1,
  itemsPerPage: 10,
});
const cantRegistros = ref();
const valorInscripcionRules = ref([
  (v) => v >= 0 || "El total debe ser mayor o igual a 0",
]);

// Modal nuevo torneo
const modalNuevoVisible = ref(false);
const modalInscripciones = ref(false);
const formValido = ref(false);
const guardando = ref(false);
const torneoEditando = ref<any>(null);
const nuevoTorneo = ref<{
  nombre: string;
  descripcion: string;
  genero: string | null;
  categoria: string | null;
  fecha: string | null;
  tipoCompetencia: string | null;
  valorInscripcion: string | number | null;
  sistemaCompetencia: string | null;
  deporte: string | null;
}>({
  nombre: "",
  descripcion: "",
  genero: null,
  categoria: null,
  fecha: null,
  tipoCompetencia: null,
  valorInscripcion: "",
  sistemaCompetencia: null,
  deporte: null,
});
const editedItem = ref({
  idTorneo: null,
  infoTorneo: "",
  sistemaCompetencia: "",
});

const editedItemFinaliza = ref({
  idTorneo: null,
  nombreTorneo: "",
  tipoCompetencia: undefined,
  categoriaTorneo: "",
  generoTorneo: "",
  deporte: null,
});

// Configuraciones
const estados = [
  { text: "Draft", value: "Draft" },
  { text: "Publicado", value: "Publicado" },
  { text: "Finalizado", value: "Finalizado" },
];

const sistemas = [
  { text: "Torneo", value: "Torneo" },
  { text: "Liga", value: "Liga" },
];

const sistemasFiltros = [{ text: "Todos", value: "Todos" }, ...sistemas];

const estadosFiltros = [{ text: "Todos", value: "Todos" }, ...estados];

const generos = [
  { text: "Masculino", value: "Masculino" },
  { text: "Femenino", value: "Femenino" },
  { text: "Mixto", value: "Mixto" },
];

const generosFiltros = [{ text: "Todos", value: "Todos" }, ...generos];

const tiposCompetencia = [
  { text: "Dobles", value: "Dobles" },
  { text: "Single", value: "Single" },
];

const categoriasModel = computed(() => {
  const categorias = getCategoriasConfig(
    proxy.$store.state.usuario.institucion.idInstitucion,
  );
  return [...categorias.categorias, ...categorias.categoriasSuma];
});

const categoriasFiltros = [
  { text: "Todos", value: "Todos" },
  ...categoriasModel.value,
];

const deportesModel = computed(() => {
  return getDeportesConfig(proxy.$store.state.usuario.institucion.idInstitucion)
    .deportes;
});

const deportesFiltros = [
  { text: "Todos", value: "Todos" },
  ...deportesModel.value,
];

const headers = [
  { text: "Nombre", value: "nombre", sortable: true },
  { text: "Descripción", value: "descripcion", sortable: true },
  { text: "Deporte", value: "deporte", sortable: true },
  { text: "Sistema Competencia", value: "sistemaCompetencia", sortable: true },
  { text: "Tipo Comp.", value: "tipoCompetencia", sortable: true },
  { text: "Genero", value: "genero", sortable: true },
  { text: "Categoría", value: "categoria", sortable: true },
  { text: "Estado", value: "estado", sortable: true },
  { text: "Fecha Inicio", value: "fechaString", sortable: true },
  { text: "Acciones", value: "acciones", sortable: false, align: "start" },
];

const footerProps = {
  itemsPerPageOptions: [5, 10, 25, 50],
  showFirstLastPage: true,
  showCurrentPage: true,
  itemsPerPageText: "Competiciones por página",
};

// Snackbar
const snackbar = ref({
  visible: false,
  mensaje: "",
  color: "success",
});

// Computed
const filtrosActivos = computed(() => {
  return (
    filtros.value.buscar ||
    filtros.value.estado ||
    filtros.value.genero ||
    filtros.value.categoria ||
    filtros.value.deporte
  );
});

// Métodos

function volver() {
  proxy.$router.push("Home");
}

function toFixed() {
  if (isNaN(parseFloat(`${nuevoTorneo.value.valorInscripcion}`)))
    nuevoTorneo.value.valorInscripcion = parseFloat(`${0.0}`).toFixed(2);
  else
    nuevoTorneo.value.valorInscripcion = parseFloat(
      nuevoTorneo.value.valorInscripcion?.toString()!,
    ).toFixed(2);
}
function onlyNumber($event: any) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
    // 46 is dot
    $event.preventDefault();
  }
}

async function cargarTorneos() {
  try {
    cargando.value = true;

    const params = {
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
      fechaDesde: filtros.value.fecha[0],
      fechaHasta: filtros.value.fecha[1],
      ...filtros.value,
      page: opcionesTabla.value.page,
      items: opcionesTabla.value.itemsPerPage,
    };

    const response = await axios.get("/Torneos/GetTorneos", { params });

    if (response.data) {
      torneos.value = response.data.torneos;
      cantRegistros.value = response.data.cantRegistros;
      console.log("torneos cargados", torneos.value);
    } else {
      torneos.value = [];
    }
  } catch (error) {
    showAlert({
      icon: "warning",
      title:
        "No se pudieron recuperar las competiciones. Intente nuevamente más tarde por favor.",
      timer: 2500,
      vm: proxy,
    });
    console.error(error);
  } finally {
    cargando.value = false;
  }
}

const onFiltroChangeDebounced = debounce(() => {
  cargarTorneos();
}, 500);

function onFiltroChange() {
  // Resetear a primera página cuando se cambian filtros
  opcionesTabla.value.page = 1;
  onFiltroChangeDebounced();
}

function quitarFiltro(filtro: string) {
  filtros.value[filtro as keyof typeof filtros.value] = "";
  onFiltroChange();
}

function limpiarFiltros() {
  setearFechaInicial();
  filtros.value = {
    ...filtros.value,
    buscar: "",
    estado: "Todos",
    genero: "Todos",
    categoria: "Todos",
    sistemaCompetencia: "Todos",
    deporte: "Todos",
  };
  onFiltroChange();
}

function getEstadoColor(estado: string) {
  const colores: Record<string, string> = {
    Draft: "warning",
    Publicado: "success",
    Finalizado: "error",
    Todos: "primary",
  };
  return colores[estado] || "grey";
}

function getSistemaColor(sistema: string) {
  const colores: Record<string, string> = {
    Torneo: "warning",
    Liga: "success",
    Todos: "primary",
  };
  return colores[sistema] || "grey";
}

function abrirNuevoTorneo() {
  torneoEditando.value = null;
  nuevoTorneo.value = {
    nombre: "",
    descripcion: "",
    genero: null,
    categoria: null,
    fecha: null,
    tipoCompetencia: null,
    valorInscripcion: "",
    sistemaCompetencia: null,
    deporte: null,
  };
  modalNuevoVisible.value = true;
  proxy.$refs.formTorneo.resetValidation();
}

async function editarTorneo(torneo: any) {
  torneoEditando.value = torneo;

  const params = {
    idTorneo: torneo.idTorneo,
  };

  const { data } = await axios.get("/Torneos/GetTorneoById", {
    params,
  });

  nuevoTorneo.value = {
    ...data,
    fecha: moment(data.fecha).format("YYYY-MM-DD"),
  };
  modalNuevoVisible.value = true;
}

async function editarPuntos(item: any) {
  const params = {
    idTorneo: item.idTorneo,
  };
  const { data } = await axios.get("/Ranking/GetRanking", {
    params,
  });

  if (!data.jugadores) {
    showAlert({
      icon: "warning",
      title: "No hay jugadores asignados para esta competencia.",
      timer: 2500,
      vm: proxy,
    });
    return;
  }

  jugadoresFinales.value = JSON.parse(data.jugadores);
  idRanking.value = data.idRanking;

  editedItemFinaliza.value = {
    idTorneo: item.idTorneo,
    nombreTorneo: item.nombre,
    tipoCompetencia: item.sistemaCompetencia,
    generoTorneo: item.genero,
    categoriaTorneo: item.categoria,
    deporte: item.deporte,
  };
  modalFinalizarVisible.value = true;
}

async function actualizarPuntos(jugadores: JugadorParaFinalizar[]) {
  try {
    const payload = {
      idTorneo: editedItemFinaliza.value.idTorneo,
      jugadores: JSON.stringify(
        jugadores.map((j) => ({
          idJugador: j.idJugador,
          nombreJugador: j.nombreJugador,
          posicion: j.ordenMerito,
          puntosAsignados: j.puntosAsignados,
        })),
      ),
      idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
      idRanking: idRanking.value,
    };

    await axios.post("/Ranking/ModificarRanking", payload);

    modalFinalizarVisible.value = false;

    showAlert({
      icon: "success",
      title: "¡Puntos actualizados correctamente!",
      text: "Los puntos han sido asignados correctamente.",
      timer: 3000,
      vm: proxy,
    });
  } catch (error) {
    showAlert({
      icon: "error",
      title: "Error",
      text: "No se pudo actualizar los puntos.",
      timer: 4000,
      vm: proxy,
    });
  }
}

function inscripciones(torneo: any) {
  editedItem.value.idTorneo = torneo.idTorneo;
  editedItem.value.infoTorneo = `${torneo.nombre} - Deporte: ${torneo.deporte} - Categoría: ${torneo.categoria} - Género: ${torneo.genero}`;
  editedItem.value.sistemaCompetencia = torneo.sistemaCompetencia;
  modalInscripciones.value = true;
}

async function guardarTorneo() {
  if (moment(nuevoTorneo.value.fecha).isBefore(moment("1900-01-01"))) {
    showAlert({
      icon: "warning",
      title: "La fecha debe ser mayor o igual al 01/01/1900.",
      timer: 2500,
      vm: proxy,
    });
    return;
  }
  try {
    const idInstitucion = proxy.$store.state.usuario.institucion.idInstitucion;

    guardando.value = true;

    if (nuevoTorneo.value.deporte === "Futbol") {
      nuevoTorneo.value.categoria = "No aplica";
      nuevoTorneo.value.tipoCompetencia = "No aplica";
    }

    const torneoData = {
      ...nuevoTorneo.value,
      configuraciones: "",
      idInstitucion,
      estado: "Draft",
    };

    let response;

    if (torneoEditando.value) {
      response = await axios.post("/Torneos/ModificarDatosTorneo", torneoData);
    } else {
      response = await axios.post("/Torneos/GuardarTorneo", torneoData);
    }

    if (response.data) {
      showAlert({
        icon: "success",
        title: `Competición ${
          torneoEditando.value ? "editada" : "creada"
        } exitosamente.`,
        timer: 2500,
        vm: proxy,
      });

      if (!torneoEditando.value && response.data) {
        // Redirigir a la configuración del torneo recién creado
        if (nuevoTorneo.value.sistemaCompetencia === "Torneo") {
          router.push(`/torneos/${idInstitucion}/${response.data}`);
        } else {
          router.push(`/ligas/${idInstitucion}/${response.data}`);
        }
      } else {
        cargarTorneos();
      }
      cerrarModalNuevo();
    }
  } catch (error) {
    showAlert({
      icon: "warning",
      title:
        "No se pudo guardar la competición. Intente nuevamente más tarde por favor.",
      timer: 2500,
      vm: proxy,
    });
    console.error(error);
  } finally {
    guardando.value = false;
  }
}

function cerrarModalNuevo() {
  modalNuevoVisible.value = false;
  torneoEditando.value = null;
}

function abrirTorneo(
  id: number,
  idInstitucion: number,
  sistemaCompetencia: string,
) {
  if (sistemaCompetencia === "Torneo") {
    router.push(`/torneos/${idInstitucion}/${id}`);
  } else {
    router.push(`/ligas/${idInstitucion}/${id}`);
  }
}

async function eliminarTorneo(idTorneo: number) {
  const result = await confirmModal({
    vm: proxy,
    title: "Eliminar competición.",
    text: "¿Está seguro que desea eliminar la competición? Esta acción no se puede deshacer.",
    icon: "warning",
    showCancelButton: true,
    showCloseButton: true,
  });

  if (!result.isConfirmed) {
    return;
  }

  try {
    await axios.get("/Torneos/EliminarTorneo", {
      params: {
        idTorneo,
      },
    });

    showAlert({
      icon: "success",
      title: "Competición eliminada exitosamente.",
      timer: 2500,
      vm: proxy,
    });
    cargarTorneos();
  } catch (error) {
    showAlert({
      icon: "warning",
      title: "La competición no pudo ser eliminada.",
      timer: 2500,
      vm: proxy,
    });
    console.error(error);
  }
}

async function cambiarEstado(idTorneo: any, estado: string) {
  if (estado === "Finalizado") {
    const result = await confirmModal({
      vm: proxy,
      title: "Finalizar competición.",
      text: "¿Está seguro que desea finalizar la competición? Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
    });

    if (!result.isConfirmed) {
      return;
    }
  }
  const datosTorneo = {
    nombre: "",
    descripcion: "",
    genero: null,
    categoria: null,
    fecha: "01/01/2025",
    tipoCompetencia: null,
    estado,
    configuraciones: "",
    idTorneo,
    idInstitucion: proxy.$store.state.usuario.institucion.idInstitucion,
  };
  try {
    await axios.post("/Torneos/CambiarEstado", datosTorneo);
    cargarTorneos();
  } catch (error) {
    console.log(error);
  }
}

function refresh() {
  cargarTorneos();
}

function setearFechaInicial() {
  const fechaInicio = moment()
    .subtract(4, "month")
    .startOf("month")
    .format("YYYY-MM-DD");

  const fechaFin = moment().add(1, "month").endOf("month").format("YYYY-MM-DD");
  filtros.value.fecha = [fechaInicio, fechaFin];
}
// Watchers
watch(
  opcionesTabla,
  () => {
    cargarTorneos();
  },
  { deep: true },
);

watch(
  () => filtros.value.fecha,
  (val) => {
    if (val && val.length === 2) {
      moment.locale("fr");
      fechaFormateada.value =
        moment(val[0]).format("L") + " - " + moment(val[1]).format("L");
      menu.value = false;
    }
  },
);

// Lifecycle
onMounted(() => {
  setearFechaInicial();
  cargarTorneos();
});
</script>

<style scoped>
.refresh-button {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}
</style>
